module.exports = __webpack_public_path__ + "assets/b03988cef1d331003dfd11ecd2956d14.png";